import React from 'react';
import _ from 'lodash';
import connectToStores from 'alt/utils/connectToStores';
import {UploadedFile} from '../forms/FileUpload.js';

import LoadingView from '../components/LoadingView';

import CompleteProfileProfessionsForm from '../forms/CompleteProfileProfessionsForm';
import CompleteProfileMyProfileForm from '../forms/CompleteProfileMyProfileForm';

import CandidateStore from '../stores/CandidateStore';
import PositionStore from '../stores/PositionStore';
import CandidateActions from '../actions/CandidateActions';

@connectToStores
class ProProfile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedLogoSrc: "",
            isLoading: false,
            settingsSaved: false
        };

        PositionStore.getPositions();
        CandidateStore.getCandidate(props.user.profile.profile.candidate_id);
    }

    static getPropsFromStores() {
        return {
            positionStore: PositionStore.getState(),
            candidateStore: CandidateStore.getState()
        };
    }

    static getStores() {
        return [CandidateStore, PositionStore];
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.candidateStore.settingsSaved !== this.state.settingsSaved) {
            //Setting timeout to give spinner a chance to show properly
            setTimeout(x => {this.setState({settingsSaved: nextProps.candidateStore.settingsSaved, isLoading: false})}, 250);
        }
        if (nextProps.candidateStore.candidateError && Object.keys(nextProps.candidateStore.candidateError).length) {
            this.setState({isLoading: false});
        }
    }

    getProfessionsFormData(professions) {
        const form_data = professions.map(profession => {
            return {
                id: profession.id,
                position: profession.position.id.toString(),
                hourlyRate: parseFloat(profession.min_hourly_rate),
                description: profession.position.description
            }
        });

        return form_data;
    }

    getProfileFormData(candidate) {
       const important_address_parts = [candidate.street, candidate.city, candidate.country].filter(part => {
            if ( part && part !== "" && part.length > 0 ){
                return part;
            }
        });
        candidate.certificates.map(certificate => { certificate.file = new UploadedFile(certificate.file.fileName, certificate.file.dataUri, certificate.file.mimeType, certificate.file.size)});
        if (Object.keys(candidate.user.profile_picture_data).length) {
            candidate.profile_picture = new UploadedFile(candidate.user.profile_picture_data.fileName, candidate.user.profile_picture_data.dataUri, candidate.user.profile_picture_data.mimeType, candidate.user.profile_picture_data.size);
        }
        candidate.address = candidate.formatted_address || important_address_parts.join(', ');
        candidate.country = candidate.country || '';
        candidate.national_insurance_number = candidate.person_code;
        candidate.phone = candidate.user.phone;
        return candidate;
    }

    saveSettings(candidateId) {
        const errors = _.merge({}, this.refs.positionsForm.validate(true).errors, this.refs.profileForm.validate(true).errors);
        const data = _.merge({}, this.refs.positionsForm.getValue(), this.refs.profileForm.getValue());
        if (Object.keys(errors).length > 0) {
            const smoothScroll = setInterval(() => {
                window.scrollBy(0, -40);
                const scrollTarget = this.refs.proProfile.getDOMNode().offsetTop + 200;
                const scrollTop = document.body.scrollTop;
                if (scrollTop <= scrollTarget) {
                    clearInterval(smoothScroll);
                }
            }, 16);
            CandidateActions.mergeErrorsIntoState(errors);
        } else if (data) {
            const candidate = this.props.candidateStore.curCandidate;

            if (data.profile_picture === null) {
                data.profile_picture = 'delete';
            } else if (data.profile_picture.dataUri === candidate.user.profile_picture_data.dataUri) {
                data.profile_picture = null;
            }

            this.setState({isLoading: true});
            data.person_code = data.national_insurance_number || '';
            data.sort_code = data.sort_code || '';
            data.user = this.props.user.profile.profile;
            data.id = candidateId;
            CandidateStore.saveProfile(candidateId, data)
        }
    }

    getSaveButton(candidateId) {
        let button = <button onClick={this.saveSettings.bind(this, candidateId)} className="btn btn-small btn-green">Save settings</button>;
        if (this.state.isLoading) {
            button = <button className="btn btn-small btn-green"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></button>;
        }
        return button;
    }

    render() {
        const positions = this.props.positionStore.positions;
        const candidate = this.props.candidateStore.curCandidate;
        const candidateError = this.props.candidateStore.candidateError;
        const settingsSaved = this.state.settingsSaved;

        if (!positions.length || !Object.keys(candidate).length) {
            return (
                <div  className={"settings-general" + (this.props.isActive ? " active" : "")}>
                    <LoadingView />
                </div>
            );
        }

        return (
            <div  className={"settings-general" + (this.props.isActive ? " active" : "")}>
                <div ref="proProfile" className="tab-section settings-form">

                    <h1 className="tab-header">My professions</h1>

                    <div className="info">You can have multiple professions. Choose one when applying for a shift.</div>

                    <CompleteProfileProfessionsForm positions={positions} initialFormData={this.getProfessionsFormData(candidate.professions)} errors={candidateError} ref="positionsForm" />

                    <div className="spacing"></div>

                    <h1 className="tab-header">Profile details</h1>

                    <CompleteProfileMyProfileForm initialFormData={this.getProfileFormData(candidate)} errors={candidateError} ref="profileForm" />

                </div>

                <div className="tab-section">
                    {this.getSaveButton(candidate.id)}
                    <p className={"data-info " + (settingsSaved ? "saved" : "")}>Settings saved!</p>
                </div>
            </div>
        );
    }

    renderSelectedLogo() {
        if (this.state.selectedLogoSrc !== "") {

            return (
                <div className="img-container">
                    <img src={this.state.selectedLogoSrc} />
                    <button className="close" onClick={this.clearLogo.bind(this)}>
                        <span>&times;</span>
                    </button>
                </div>
            );
        }
    }

    clearLogo() {
        React.findDOMNode(this.refs.logoInput).value = "";
        this.setState({
            selectedLogoSrc: ""
        });
    }

    logoSelected(evt) {
        var file = evt.nativeEvent.srcElement.files[0];

        if (typeof file !== 'undefined') {

            var reader = new FileReader();

            reader.onloadend = function () {
                this.setState({
                    selectedLogoSrc: reader.result
                });
            }.bind(this);

            reader.readAsDataURL(file);
        }
    }
}

export default ProProfile;



/** WEBPACK FOOTER **
 ** ./app/src/components/ProProfile.js
 **/